/**
 * Aufloesung des Login-Kennzeichens.
 *
 * Sicherheitsregel: Die App speichert KEINE Passwoerter im Frontend. Appwrite 1.8
 * kennt ausschliesslich den E-Mail/Passwort-Login (`createEmailPasswordSession`).
 *
 * Der gewohnte Benutzername (z. B. "Dervis90") soll weiterhin funktionieren.
 * Deshalb wird ein Benutzername ueber die Team-Liste
 * (VITE_APPWRITE_TEAM_USERS: [{ id, name, email, ... }]) auf die Konten-E-Mail
 * abgebildet. Die Zuordnung ist nur eine Aufloesung von Name -> E-Mail,
 * keine eigene Benutzerverwaltung und kein Passwort-Speicher.
 */

const parseTeamUsers = () => {
  try {
    const raw = import.meta.env.VITE_APPWRITE_TEAM_USERS;
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((u) => u && u.email && !u.is_ai);
  } catch (e) {
    console.warn('Team-User-Konfiguration ungueltig:', e.message);
    return [];
  }
};

/**
 * Loest eine Eingabe (E-Mail oder Benutzername) auf.
 *
 * @param {string} identifier E-Mail-Adresse oder Benutzername
 * @returns {{ email: string, name: string, known: boolean }}
 *   email  - E-Mail-Adresse fuer den Appwrite-Login (leer, wenn unbekannt)
 *   name   - Anzeigename des Kontos
 *   known  - true, wenn die Eingabe einem Team-Konto entspricht
 */
export const resolveLoginIdentifier = (identifier) => {
  const value = String(identifier || '').trim();
  if (!value) return { email: '', name: '', known: false };

  const team = parseTeamUsers();
  const lower = value.toLowerCase();

  // E-Mail-Adresse: direkt uebernehmen (mit Anzeigenamen, falls bekannt)
  if (value.includes('@')) {
    const match = team.find((u) => String(u.email).toLowerCase() === lower);
    return { email: value, name: match?.name || '', known: true };
  }

  // Benutzername: ueber die Team-Liste aufloesen
  const match = team.find((u) => String(u.name).toLowerCase() === lower);
  if (match) return { email: match.email, name: match.name, known: true };

  return { email: '', name: value, known: false };
};

/**
 * Liefert die Team-Liste fuer Anzeigezwecke (z. B. Benutzernamen-Autovervollstaendigung).
 * @returns {Array<{id: string, name: string, email: string}>}
 */
export const getLoginHints = () =>
  parseTeamUsers().map((u) => ({ id: u.id, name: u.name, email: u.email }));
